import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountManagerInfo} from 'src/openapi/admin/apis/AccountManagerRelationsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useGetAccountTeamMembers = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountManagerInfo({accountId}),
    ), [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        getDispatchAction,
        initValue: [],
    });
};
